<script>
import i18n from "../i18n";
import simplebar from "simplebar-vue";
import { layoutComputed } from "@/state/helpers";
import SetCycle from "./modals/set-cycle.vue";
import SetCampus from "./modals/set-campus.vue";
import SetDeliveryUnit from "./modals/set-delivery-unit.vue";
import vClickOutside from 'v-click-outside'

/**
 * Horizontal-topbar component
 */
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: true,
        },
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    computed: {
        ...layoutComputed,
        setCycle: {
            get() {
                return this.$store.getters["data/getCycle"];
            },
            set(newValue) {
                return newValue;
            },
        },
        notifSeen() {
            let data = this.$store.state.notification.notifications;
            data = data.filter((item) => {
                return item.status.toLowerCase() === "unread";
            });
            return data;
        },
        setCampus: {
            get() {
                return this.$store.getters["data/getCampus"];
            },
            set(newValue) {
                return newValue;
            },
        },
        setDU: {
            get() {
                return this.$store.getters["data/getDU"];
            },
            set(newValue) {
                return newValue;
            },
        },
    },
    components: {
        simplebar,
        SetCycle,
        SetCampus,
        SetDeliveryUnit,
    },
    data() {
        return {
            username: JSON.parse(localStorage.getItem("user")).userName,
            alert: {
                type: "",
                message: "",
            },
            notifications: [],
            myInterval: null,
            showPV: false,
            duAccess: JSON.parse(localStorage.getItem('duAccess')),
            isAdmin: this.$store.state.decrypt.isAdmin(),
            accessList: this.$store.state.decrypt.userAccessList(),
            theme: localStorage.getItem("theme") || "dark",
            staging: false,
        };
    },
    mounted() {
        if(process.env.NODE_ENV === 'production'){
            this.staging = false;
        }else{
            this.staging = true;
        }
        this.getDashboardData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
    },
    methods: {
        changeCycle(cycle) {
            this.getDashboardData(cycle, this.$store.state.data.selectedCampus.id, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
            this.$emit("changeCycle", cycle);
        },
        changeCampus(campus) {
            this.getDashboardData(this.$store.state.data.cycle, campus.id, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
            this.changeMenuOPCRWFP();
            this.$emit("changeCampus", campus);
        },
        changeDU(du){
            this.getDashboardData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, du.id, this.$store.state.data.selectedDepartment.id);
            this.$emit("changeDU", du);
        },
        changeDepartment(department){
            this.getDashboardData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, this.$store.state.data.selectedDU.id, department.id);
            this.$emit("changeDepartment", department);
        },
        toggleRightSidebar() {
            this.$parent.toggleRightSidebar();
        },
        toggleMenu() {
            let element = document.getElementById("topnav-menu-content");
            element.classList.toggle("show");
        },
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (
                !document.fullscreenElement &&
                /* alternative standard method */ !document.mozFullScreenElement &&
                !document.webkitFullscreenElement
            ) {
                // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(
                        Element.ALLOW_KEYBOARD_INPUT
                    );
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
        setDUModal() {
            this.$refs.setDUMdl.resetData();
            this.$bvModal.show("set-du-modal");
        },
        setCampusModal() {
            this.$bvModal.show("set-campus-modal");
        },
        setCycleModal() {
            this.$bvModal.show("set-cycle-modal");
        },
        setLanguage(locale, country, flag) {
            this.current_language = locale;
            this.text = country;
            this.flag = flag;
            i18n.locale = locale;
        },
        clearAllNotification(event) {
            event.preventDefault()
            this.$store.dispatch("notification/DeleteAllNotif").then((res) => {
                this.$store.commit("notification/SET_NOTIFICATIONS", []);
                this.showPV = true;
            });
        },
        viewNotif(row) {
            this.$store.commit("notification/OPEN_OPTIONS", {row: row, showDeleteOption: false});
            this.$store
                .dispatch("notification/SeenNotif", row.id)
                .then((res) => {
                    this.$store.commit("notification/SEEN_STATUS", {row: row, status: "Seen"});
                });
            if(row.type.toUpperCase() === "TRACK_RETURNED"){
                if(this.$route.name === 'office tracks'){
                    return;
                }
                this.$router.push({ name: "dts-office-tracks" });
            }
            if(row.type.toUpperCase() === "API RESOURCE"){
                if(this.$route.name === 'myAPI' && this.$route.params.id == row.referenceId && this.$route.params.type === 'resource'){
                    return;
                }
                this.$router.push({ name: "myAPI", params: { id: row.referenceId, type: 'resource' } });
            }
            if(row.type.toUpperCase() === 'PR'){
                if(this.$route.name === 'pr' && this.$route.params.id == row.referenceId){
                    return;
                }
                this.$router.push({ name: "pr", params: { id: row.referenceId } });
            }
        },
        deleteNotif(id) {
            this.$store.dispatch("notification/DeleteNotif", id).then((res) => {
                this.$store.commit("notification/REMOVE_NOTIFICATION", id);
            });
        },
        longPress(row) {
            this.$store.commit("notification/OPEN_OPTIONS", {row: row, showDeleteOption: !row.showDeleteOption});
        },
        getDiffDate() {
            this.$store.commit("notification/UPDATE_DATES");
        },
        stopDiffDate(){
            this.myInterval && clearInterval(this.myInterval);
            this.myInterval = null;
        },
        goToNotifications() {
            this.$router.push({ name: "notifications" });
        },
        getDashboardData(cycle, campusId, deliveryUnitId, departmentId){
            var dashboardData = null;
            this.$store
                .dispatch("dashboard/GetMenuCounts", {cycle, campusId, deliveryUnitId})
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    dashboardData = res.data;
                    dashboardData.incomingTracks = 0;
                    dashboardData.returnedTracks = 0;
                    dashboardData.incomingDepartmentTracks = 0;
                    dashboardData.returnedDepartmentTracks = 0;
                    this.$store
                        .dispatch("dtstrack/GetDashboardData", { deliveryUnitId, departmentId: departmentId ? departmentId : 0 })
                        .then(async (res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            dashboardData.incomingTracks = res.data.incomingTrackCount;
                            dashboardData.returnedTracks = res.data.returnedTrackCount;
                            dashboardData.incomingDepartmentTracks = res.data.incomingTrackDepartmentCount;
                            dashboardData.returnedDepartmentTracks = res.data.returnedTrackDepartmentCount;
                            localStorage.setItem('dashboardData', JSON.stringify(dashboardData));
                            if(this.$store.state.decrypt.isAdmin() || (this.accessList.length && this.accessList.find(x => x.Type.toLowerCase() === 'planning'))){
                                this.getPostedTargetCount(cycle, campusId);
                                this.getSubmittedTargetCount(cycle, campusId);
                            }
                            await this.wait(1000);
                            this.changeMenuOPCRWFP();
                            this.changeMenuPMEPMT();
                            this.attachedDUNotifications(dashboardData);
                            this.attachedDepartmentNotifications(dashboardData);
                            this.attachedFinanceNotifications(dashboardData);
                        });
                })
                .catch((err) => {
                    return this.showToast(
                        "Something went wrong! - Getting Allocations",
                        "error"
                    );
                });
        },
        getPostedTargetCount(cycle, campusId) {
            this.$store
                .dispatch("target/GetPostedTargetCount", { campusId, cycle })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
                    dashboardData.pmeReview = res.data;
                    localStorage.setItem('dashboardData', JSON.stringify(dashboardData));
                })
                .catch((err) => {
                return this.showToast(
                    "Something went wrong! - Getting Allocations",
                    "error"
                );
            });
        },
        getSubmittedTargetCount(cycle, campusId) {
            this.$store
                .dispatch("target/GetSubmittedTargetCount", { campusId, cycle })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
                    dashboardData.pmtRating = res.data;
                    localStorage.setItem('dashboardData', JSON.stringify(dashboardData));
                })
                .catch((err) => {
                return this.showToast(
                    "Something went wrong! - Getting Allocations",
                    "error"
                );
            });
        },
        changeTheme() {
            if (this.theme === "dark") {
                this.theme = "light";
                document.body.setAttribute("data-theme", "light");
                document.body.setAttribute("data-topbar", "colored");
                localStorage.setItem("theme", "light");
                document.body.style.backgroundColor = '#fff';
            } else {
                this.theme = "dark";
                document.body.setAttribute("data-theme", "dark");
                document.body.setAttribute("data-topbar", "light");
                localStorage.setItem("theme", "dark");
                document.body.style.backgroundColor = '#262b3c';
            }
        },
        async logoutUser() {
            try{
                await this.$store.dispatch("account/Logout");
            } catch (error) {
                console.error("Logout failed:", error);
            } finally {
                var theme = localStorage.getItem("theme");
                localStorage.clear();
                if(theme) {
                    localStorage.setItem("theme", theme);
                }
                window.location.href = "/";
            }
            
        },
    },
    watch: {
        // type: {
        //     immediate: true,
        //     handler(newVal, oldVal) {
        //         if (newVal !== oldVal) {
        //             switch (newVal) {
        //                 case "dark":
        //                     document.body.setAttribute("data-topbar", "dark");
        //                     document.body.removeAttribute(
        //                         "data-layout-scrollable"
        //                     );
        //                     break;
        //                 case "light":
        //                     document.body.setAttribute("data-topbar", "light");
        //                     document.body.removeAttribute(
        //                         "data-layout-size",
        //                         "boxed"
        //                     );
        //                     document.body.removeAttribute(
        //                         "data-layout-scrollable"
        //                     );
        //                     break;
        //                 case "colored":
        //                     document.body.setAttribute(
        //                         "data-topbar",
        //                         "colored"
        //                     );
        //                     document.body.removeAttribute(
        //                         "data-layout-size",
        //                         "boxed"
        //                     );
        //                     break;
        //                 default:
        //                     document.body.setAttribute("data-topbar", "dark");
        //                     break;
        //             }
        //         }
        //     },
        // },
        width: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    switch (newVal) {
                        case "boxed":
                            document.body.setAttribute(
                                "data-layout-size",
                                "boxed"
                            );
                            break;
                        case "fluid":
                            document.body.setAttribute(
                                "data-layout-mode",
                                "fluid"
                            );
                            document.body.removeAttribute("data-layout-size");
                            break;
                        case "scrollable":
                            document.body.setAttribute(
                                "data-layout-scrollable",
                                "true"
                            );
                            document.body.removeAttribute("data-layout-mode");
                            document.body.removeAttribute("data-layout-size");
                            break;
                        default:
                            document.body.setAttribute(
                                "data-layout-mode",
                                "fluid"
                            );
                            break;
                    }
                }
            },
        },
        showPV: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    if(newVal){
                        this.getDiffDate();
                    }else{
                        this.stopDiffDate();
                    }
                }
            }
        },
    },
};
</script>

<template>
    <header id="page-topbar">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box text-left">
                    <router-link to="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img
                                src="@/assets/images/logo/g-white.png"
                                style="height: 45px"
                            />
                        </span>
                        <span class="logo-lg">
                            <img
                                src="@/assets/images/logo/g-white.png"
                                style="height: 45px"
                            />
                        </span>
                    </router-link>

                    <router-link to="/" class="logo-light">
                        <span class="logo-sm">
                            <!-- <img src="@/assets/images/logo/g-white.png" style="height:45px;"/> -->
                        </span>
                        <span class="logo-lg d-flex align-items-end position-relative">
                            <div class="d-flex align-items-end">
                                <h4 class="logo-lg text-white mt-2 mb-0 d-flex align-items-center">
                                    <img
                                        src="@/assets/images/logo/giams-logo.svg"
                                        style="height: 50px"
                                    />
                                    <span class="ms-1 text-danger font-weight-bold" style="font-size:25px;" v-if="staging">(STAGING)</span>
                                </h4>
                            </div>
                            <div class="d-none d-sm-inline-block position-absolute" style="left:56px;bottom:-3px;">
                                <small class="text-white text-truncate" id="for-du-campus-pv"
                                    >{{ $store.state.data.selectedCampus.campusName }} |
                                    <template v-if="$store.state.data.selectedDU">
                                        <span>
                                        {{
                                            $store.state.data.selectedDU.name.length > 70 ? `${$store.state.data.selectedDU.name.substring(0, 70)}...` : $store.state.data.selectedDU.name
                                        }}
                                        </span>
                                        |
                                        <span v-if="$store.state.data.selectedDepartment">{{$store.state.data.selectedDepartment.departmentName}}</span>
                                    </template>
                                    <span v-else>No DU Selected</span>
                                    </small
                                >
                                <b-popover
                                    :target="'for-du-campus-pv'"
                                    triggers="hover"
                                    placement="right"
                                >
                                    <div>
                                        <b class="text-white">{{ $store.state.data.selectedCampus.campusName }}</b>
                                    </div>
                                    <div class="mt-2">
                                        {{ $store.state.data.selectedDU ? $store.state.data.selectedDU.name : 'No DU Selected'}}
                                    </div>
                                    <div v-if="$store.state.data.selectedDepartment">
                                        <small>{{ $store.state.data.selectedDepartment ? $store.state.data.selectedDepartment.departmentName : 'No Department Selected'}}</small>
                                    </div>
                                </b-popover>
                            </div>
                        </span>
                    </router-link>
                </div>
                <button
                    id="toggle"
                    type="button"
                    class="btn btn-sm me-2 font-size-16 d-lg-none header-item"
                    @click="toggleMenu"
                >
                    <i class="fa fa-fw fa-bars"></i>
                </button>
            </div>
            <div class="d-flex align-items-center">
                <b-dropdown
                    class="d-inline-block d-lg-none ms-2"
                    variant="black"
                    menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
                    toggle-class="header-item noti-icon"
                    right
                >
                    <template v-slot:button-content>
                        <i class="mdi mdi-magnify"></i>
                    </template>

                    <form class="p-3">
                        <div class="form-group m-0">
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Search ..."
                                    aria-label="Recipient's username"
                                />
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                    >
                                        <i class="mdi mdi-magnify"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </b-dropdown>
                <div
                    class="dropdown d-none d-lg-inline-block ms-1"
                    :title="`Set ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
                >
                    <button
                        v-if="$store.state.decrypt.campusAccessList().length > 1"
                        type="button"
                        class="btn header-item noti-icon custom-header-btn"
                        @click="setCampusModal"
                    >
                        <div class="font-weight-bold">
                            {{ setCampus.campusName }}
                        </div>
                    </button>
                </div>
                <div
                    class="dropdown d-none d-lg-inline-block ms-1"
                    :title="`Set Delivery Unit - ${setDU ? setDU.name : 'No DU Selected'}`"
                >
                    <button
                        v-if="isAdmin || duAccess.length > 1"
                        type="button"
                        class="btn header-item noti-icon custom-header-btn"
                        @click="setDUModal"
                    >
                        <div class="font-weight-bold" v-if="setDU">
                            {{ setDU.name.length > 30 ? `${setDU.name.substring(0, 30)}...` : setDU.name }}
                        </div>
                        <div v-else>
                            No DU Selected
                        </div>
                    </button>
                </div>
                <div
                    class="dropdown d-none d-lg-inline-block ms-1"
                    title="Set Cycle"
                >
                    <button
                        type="button"
                        class="btn header-item noti-icon"
                        @click="setCycleModal"
                    >
                        {{ setCycle }}
                    </button>
                </div>

                <div class="dropdown d-none d-lg-inline-block ms-1">
                    <button
                        type="button"
                        class="btn header-item noti-icon"
                        @click="changeTheme"
                        :title="`Switch to ${theme === 'light' ? 'Dark' : 'Light'} Mode`"
                    >
                        <i class="bx " :class="[theme === 'light' ? 'bx-moon' : 'bx-sun']"></i>
                    </button>
                    <!-- <button
                        type="button"
                        class="btn header-item noti-icon"
                        @click="initFullScreen"
                    >
                        <i class="bx bx-fullscreen"></i>
                    </button> -->
                </div>
                <div class="d-none d-lg-inline-block ms-1">
                    <button
                        type="button"
                        class="btn header-item noti-icon position-relative"
                        id="notification-popover"
                        
                    >
                        <i
                            class="bx bx-bell"
                            :class="{
                                'bx-tada': notifSeen.length > 0,
                            }"
                        ></i>
                        <span
                            class="badge bg-danger rounded-pill"
                            v-if="notifSeen.length > 0"
                            >{{ notifSeen.length }}</span
                        >
                    </button>
                    <b-popover
                        target="notification-popover"
                        triggers="click blur"
                        placement="bottomleft"
                        custom-class="notif-popover"
                        :show.sync="showPV"
                    >
                        <div class="p-3">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6
                                        class="m-0"
                                        :class="{
                                            'text-center':
                                                this.$store.state.notification.notifications.length == 0,
                                        }"
                                    >
                                        {{
                                            this.$store.state.notification.notifications.length > 0
                                                ? "Notifications"
                                                : "There's no notifications"
                                        }}
                                    </h6>
                                </div>
                                <div
                                    class="col-auto"
                                    v-if="this.$store.state.notification.notifications.length > 0"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        class="small"
                                        @click="clearAllNotification"
                                        >Clear All</a
                                    >
                                </div>
                            </div>
                        </div>
                        <simplebar
                            style="max-height: 250px; overflow-x: hidden"
                        >
                            <a
                                href="javascript: void(0);"
                                class="
                                    text-reset
                                    notification-item
                                    position-relative
                                    w-100
                                "
                                :class="{
                                    'notification-item':
                                        x.status.toLowerCase() !== 'seen',
                                }"
                                v-for="x in this.$store.state.notification.notifications"
                                :key="x.id"
                            >
                                <div
                                    class="media"
                                    :class="{
                                        'bg-primary bg-soft':
                                            x.status.toLowerCase() !== 'seen',
                                    }"
                                    @click="viewNotif(x)"
                                >
                                    <div class="avatar-xs me-3">
                                        <span
                                            class="
                                                avatar-title
                                                bg-primary
                                                rounded-circle
                                                font-size-16
                                            "
                                        >
                                            <i class="bx bx-file"></i>
                                        </span>
                                    </div>
                                    <div class="media-body">
                                        <h6
                                            class="
                                                mt-0
                                                mb-1
                                                cursor-pointer
                                                hoverable-link
                                            "
                                        >
                                            {{ x.title }}
                                        </h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1 text-clamp">
                                                {{ x.description }}
                                            </p>
                                            <p class="mb-1">
                                                <i
                                                    class="
                                                        mdi mdi-clock-outline
                                                    "
                                                ></i>
                                                {{ x.returnDate }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="
                                        d-flex
                                        position-absolute
                                        align-items-center
                                        justify-content-center
                                        arrow-notif
                                        bg-opacity-100
                                    "
                                    :class="{ active: x.showDeleteOption }"
                                    @click="longPress(x)"
                                >
                                    <i
                                        class="
                                            bx bx-chevron-left
                                            font-size-20
                                            rotate
                                        "
                                        style="padding: 0 5px"
                                        :class="{
                                            'rotate-180': x.showDeleteOption,
                                        }"
                                    ></i>
                                    <div
                                        class="
                                            d-flex
                                            align-items-center
                                            justify-content-center
                                            bg-danger bg-gradient
                                            text-light
                                            delete-notif
                                        "
                                        @click="deleteNotif(x.id)"
                                    >
                                        <i
                                            class="bx bx-trash"
                                            v-if="x.showDeleteOption"
                                        ></i>
                                    </div>
                                </div>
                            </a>
                        </simplebar>
                        <div class="p-2 border-top d-grid" v-if="this.$store.state.notification.notifications.length > 0">
                            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)" @click="goToNotifications"><i class="mdi mdi-arrow-right-circle me-1"></i> View More..</a>
                        </div>
                    </b-popover>
                </div>
                <b-dropdown
                    menu-class="dropdown-menu-end"
                    variant="black"
                    toggle-class="header-item d-flex align-items-center"
                >
                    <template v-slot:button-content>
                        <div
                            class="
                                rounded-circle
                                header-profile-user
                                bg-success bg-gradient
                                text-white
                                d-flex
                                align-items-center
                                justify-content-center
                                font-size-15
                                border border-3 border-secondary
                            "
                        >
                            {{ username.slice(0, 2).toUpperCase() }}
                        </div>
                        <span class="d-none d-xl-inline-block ms-1">{{
                            username
                        }}</span>
                        <i
                            class="
                                mdi mdi-chevron-down
                                d-none d-xl-inline-block
                            "
                        ></i>
                    </template>
                    <b-dropdown-item class="d-block" href="/account-settings">
                        <i
                            class="bx bx-wrench font-size-16 align-middle me-1"
                        ></i>
                        Account Settings
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a href="javascript::void(0);" class="dropdown-item text-danger" @click="logoutUser">
                        <i
                            class="
                                bx bx-power-off
                                font-size-16
                                align-middle
                                me-1
                                text-danger
                            "
                        ></i>
                        {{ $t("navbar.dropdown.henry.list.logout") }}
                    </a>
                </b-dropdown>

                <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->
            </div>
        </div>
        <set-cycle @changeCycle="changeCycle"></set-cycle>
        <set-campus @changeCampus="changeCampus" @changeDU="changeDU"></set-campus>
        <set-delivery-unit @changeDU="changeDU" @changeCampus="changeCampus" @changeDepartment="changeDepartment" ref="setDUMdl"></set-delivery-unit>
    </header>
</template>
